import { connect } from 'react-redux';
import { getInstantExperiences, getInstantExperiencesOwner } from '../instantExperiences/selectors';

const WithInstantExperiences = connect(state => ({
  instantExperiences: getInstantExperiences(state),
  getInstantExperiencesOwner: getInstantExperiencesOwner(state),
}));

export default WithInstantExperiences;



// WEBPACK FOOTER //
// ./src/app/hoc/WithInstantExperiences.js